import React, { useRef } from 'react';
import { useState, useEffect, usePrintContext, Hooks, Form, Field, Name, Title, Info, Code, Actions, Toast,  API, Utility, Button, Files, Control, Messages, OptionType } from 'helpers/PrintImports';
import { Orders } from "models/OrdersModel";
import { Client } from 'models/ClientModel';
import { ItemInventory } from "models/ItemInventoryModel";
import { CommonDataColumn } from "models/BaseModel";

const LabOrderPrint: React.FC = () => {
  const [formId, formName] = [Code.Form.Id.ORDERS, Code.Form.Name.ORDERS];
  const {keyId, loading, setLoading, showMenu, setShowMenu, message, setMessage, error, setError, menuPosition, setMenuPosition, contextMenuRef, iframeRef } = usePrintContext();
  const [orderData, setOrderData] = useState<Orders>({});
  const [clientData, setClientData] = useState<Client>({});
  const [itemInventoryData, setItemInventoryData] = useState<ItemInventory[]>([]); 
  const [examData, setExamData] = useState<CommonDataColumn>();
  const [frameData, setFrameData] = useState<CommonDataColumn>();
  const [lensTypeRight, setLensTypeRight] = useState<string>('');
  const [lensTypeLeft, setLensTypeLeft] = useState<string>('');
  const [lensIndexRight, setLensIndexRight] = useState<string>('');
  const [lensIndexLeft, setLensIndexLeft] = useState<string>('');
  const [lensFilterRight, setLensFilterRight] = useState<string>('');
  const [lensFilterLeft, setLensFilterLeft] = useState<string>('');
  const [instruction, setInstruction] = useState<string>('');

  const [checkMaterialplastic, setCheckMaterialPlastic] = useState<boolean>(false);
  const [checkMaterialPoly, setCheckMaterialPoly] = useState<boolean>(false);
  const [checkMaterialTrivex, setCheckMaterialTrivex] = useState<boolean>(false);
  const [checkUltraARECC, setCheckUltraARECC] = useState<boolean>(false);
  const [checkUltraAR, setCheckUltraAR] = useState<boolean>(false);
  const [checkUltraBACKAR, setCheckUltraBACKAR] = useState<boolean>(false);
  const [checkSeeCoat, setCheckSeeCoat] = useState<boolean>(false);
  const [checkICE, setCheckICE] = useState<boolean>(false);
  const [checkHCC, setCheckHCC] = useState<boolean>(false);
  const [checkMultiClear, setCheckMultiClear] = useState<boolean>(false);
  const [checkHardCoatTint, setCheckHardCoatTint] = useState<boolean>(false);
  const [checkHardCoat, setCheckHardCoat] = useState<boolean>(false);
  const [checkNikonHC, setCheckNikonHC] = useState<boolean>(false);
  const [checkSRC2, setCheckSRC2] = useState<boolean>(false);
  const [checkUV400ONPlastic, setCheckUV400ONPlastic] = useState<boolean>(false);
  const [checkEdgePolish, setCheckEdgePolish] = useState<boolean>(false);
  const [checkChemHardening, setCheckChemHardening] = useState<boolean>(false);

  const [accountId, setAccountId] = useState<string | undefined>('');
  const [todayDay, setTodayDay] = useState<number | undefined>();
  const [todayMonth, setTodayMonth] = useState<number | undefined>();
  const [todayYear, setTodayYear] = useState<number | undefined>();
  const [logoUrl, setLogoUrl] = useState<string | null >(null);


  

  Form.Click.Outside([contextMenuRef],[() => setShowMenu(false),() => {}],true);
  const Privilege = Hooks.Privilege.List(formId);
  Hooks.Privilege.HasPrint(Privilege);
  const printRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    API.Data.GetByKeyId<Orders>(formName, keyId, setLoading, setError)
      .then(async(data) => { if(data) {
      const formData = await Form.Map.Data(data);
      setOrderData((prevData) => ({
        ...prevData,
        ...formData,
      }));

      var location = await API.Data.GetLocation(data.location_id!);
      if(location){
        setAccountId(location.lab_number)
      }

      var client = await API.Data.GetClient(data.client_id);
      if(client){
        setClientData(client);
      }

      const now = new Date();
      setTodayDay(now.getDate());
      setTodayMonth(now.getMonth() + 1);
      setTodayYear(now.getFullYear());
      
      callItemList(data.orders_id);

      const url = await Files.ImageAPI.Fetch("doctorsopticallab.png");
      setLogoUrl(url);

      console.log("url------>",url);

      // setDoctorData(await API.Data.GetDoctor(data.doctor_id));
      // setUserData(await API.Data.GetUser(data.user_id));
    }})
    setLoading(false);
  }, []); 

  const callItemList = async (ordersId: number | undefined) => {
    if (!ordersId) return;  
      const url = API.Build.FormApiEndpint(Code.Form.Name.ITEM, 200, Name.Item.Id, Code.Option.Sort.ASC, {
      fields: Utility.Join.Fields([
        Name.Item.All, 
        Name.Product.Name, 
        Name.Item.UTN,
        Name.Item.SKU,
        Name.Item.ItemStatusName,
        Name.Item.OrderStatusName,
        Name.Inventory.Data,
        Name.Specification.Id,
      ]),
      [Name.Common.FormId]: Code.Form.Id.ORDERS,
      [Name.Common.CommonId]: ordersId,
    });
    console.log("Item List URL----------->:",url);
    await API.Data.List<ItemInventory>(url, setItemInventoryData, setError, setLoading);
  };

  useEffect(() => {
    if (!itemInventoryData || itemInventoryData.length === 0) return;

    console.log("itemInventoryData ---->", itemInventoryData);

    

    itemInventoryData.forEach((item) => {

      var data =   item.inventory_data;
      if(data){
        
        if(item.specification_id == Number(Code.Option.Control.FRAME)){
          var frame = JSON.parse(data) as CommonDataColumn;
          if(frame){
            setFrameData(frame);
          }
        }
        else if(item.specification_id == Number(Code.Option.Control.LENS)){
          var lens = JSON.parse(data) as CommonDataColumn;
          if(lens){
            var labInfo = lens.D55;
            var materialInfo = lens.D56;
            var lensInfo = lens.D57;
            var colorInfo = lens.D59;
            var sourceInfo = lens.D60;

            data = data.toLowerCase();

            var value1 = "";
            var value2 = "";

            if (data.includes("single") || data.includes("sv")) { value1 = "S.V."; value2 = "S.V."; }
            else if (data.includes("bifocal")) 
            { 

                value1 = "Bifocal";
                if (data.includes("ft28")) { value2 = "FT28";  }
                else if (data.includes("rd28")) { value2 = "RD28";  }
                else { value2 = "Bifocal";  }
            }
            else if (data.includes("progressive") && data.includes("harmony")) { value1 = "Progressive"; value2 = "Harmony"; }
            else if (data.includes("harmony")) { value1 = "Harmony"; value2 = "Harmony"; }
            else if (data.includes("progressive")) { value1 = "Progressive"; value2 = "Progressive"; }

            setLensTypeRight(value1)
            setLensTypeLeft(value2)

            value1 = ""; value2 = "";

            if(materialInfo){
              materialInfo = materialInfo.toLowerCase();
              if (materialInfo.includes("plastic")) { setCheckMaterialPlastic(true); }
              else if (materialInfo.includes("poly")) { setCheckMaterialPoly(true); }
              else if (materialInfo.includes("trivex")) { setCheckMaterialTrivex(true); }
            }

            if(lensInfo){
              lensInfo = lensInfo.toLowerCase();
              if(lensInfo.includes("1.5")) { value1 = "1.5";  }
              else if (lensInfo.includes("1.6")) { value1 = "1.6"; }
              else if (lensInfo.includes("1.67")) { value1 = "1.67"; }
              else if (lensInfo.includes("1.74")) { value1 = "1.74"; }

              setLensIndexRight(value1);
              setLensIndexLeft(value1);
            }

            value1 = ""; value2 = "";

            if(lensInfo){
              lensInfo = lensInfo.toLowerCase();
              if (lensInfo.includes("bluex") && lensInfo.includes("photochromatic")) { value1 = "Bluex Photochromatic"; }
              else if (lensInfo.includes("bluex")) { value1 = "Bluex"; }
              else if (lensInfo.includes("photochromatic")) { value1 = "Photochromatic"; }
              else if (lensInfo.includes("polar")) { value1 = "Polar"; }
              else if (lensInfo.includes("trans")) { value1 = "Trans"; }

              setLensFilterRight(value1);
              setLensFilterLeft(value1);

              value1 = ""; value2 = "";

              if (lensInfo.includes("reader")) { value1 = "Readers Only"; }
              else if (lensInfo.includes("distance")) { value1 = "Distance Only"; }

              setInstruction(value1);

              

              if (lensInfo.includes("ecc") && lensInfo.includes("arc")) { setCheckUltraARECC(true); }
              else if(lensInfo.includes("ultra ar") || lensInfo.includes("uar") || lensInfo.includes("arc")) { setCheckUltraAR(true); }
              else if(lensInfo.includes("ultra back")) { setCheckUltraBACKAR(true); }
              else if(lensInfo.includes("seecoat")) { setCheckSeeCoat(true); }
              else if(lensInfo.includes("ice")) { setCheckICE(true); }
              else if(lensInfo.includes("hcc")) { setCheckHCC(true); }
              else if(lensInfo.includes("multi clear")) { setCheckMultiClear(true); }
              else if((lensInfo.includes("hard coat") || lensInfo.includes("hc")) && lensInfo.includes("Tint")) { setCheckHardCoatTint(true); }
              else if(lensInfo.includes("hard coat") || lensInfo.includes("hc")) { setCheckHardCoat(true); }
              else if(lensInfo.includes("nikon hc")) { setCheckNikonHC(true); }
              else if(lensInfo.includes("src2")) { setCheckSRC2(true); }
              else if(lensInfo.includes("uv400")) { setCheckUV400ONPlastic(true); }
              else if(lensInfo.includes("polish")) { setCheckEdgePolish(true); }
              else if(lensInfo.includes("hardening")) { setCheckChemHardening(true); }


              console.log("lensInfo----->",lensInfo,checkUltraARECC);
            }

          }
        }
        else if(item.specification_id == Number(Code.Option.Control.EXAM)){
          var exam = JSON.parse(data) as CommonDataColumn;
          if(exam){
            setExamData(exam);
          }
          
        }
      }

      
    });

  }, [itemInventoryData]);


  

  type Props = {
    type?: "lab-check" | "lab-check2" | "lab-check3" | "lab-tick" | "lab-tick2" | "lab-tick3";
  };

  const CheckToggle: React.FC<Props> = ({ type = "lab-check" }) => {
    // Determine initial state: if the type starts with "lab-tick", it is active
    const initialActive = type.startsWith("lab-tick");
    const [active, setActive] = useState(initialActive);

    const className = `${getBaseClass(type)} ${active ? getTickClass(type) : ""}`;

    return (
      <span className={className} onClick={() => setActive(prev => !prev)}>
        &nbsp;
      </span>
    );
  };

  // Convert tick → check and keep base class consistent
  function getBaseClass(type: string): string {
    switch (type) {
      case "lab-tick": return "lab-check";
      case "lab-tick2": return "lab-check2";
      case "lab-tick3": return "lab-check3";
      default: return type;
    }
  }

  function getTickClass(type: string): string {
    switch (type) {
      case "lab-check":
      case "lab-tick":
        return "lab-tick";

      case "lab-check2":
      case "lab-tick2":
        return "lab-tick2";

      case "lab-check3":
      case "lab-tick3":
        return "lab-tick3";

      default:
        return "";
    }
  }


  return (
    <Control.Print.Frame setMenuPosition={setMenuPosition} setShowMenu={setShowMenu}>
      {!loading && (<>
        <Messages.Toast Messages={message} Error={error} />
        <Button.Print keyId={keyId} formName='Lab-Order' Privilege={Privilege} clientData={clientData} fileName={orderData.orders_number} printRef={printRef} setMessage={setMessage} setError={setError} />
        <Control.Print.Data ref={printRef}>
            <div className="lab-head">
              <div className="flbox">
                  <div className="fleft page-col50">
                      <div>{logoUrl ? <img src={logoUrl} alt="Doctor Sign" /> : null} </div>
                      <div className="fwb">Rx ORDER FORM</div>
                  </div>
                  <div className="fleft page-col50 lab-address pt4">
                      <div><span>P:</span> 403.250.1314 <span>Toll Free Ph:</span> 1.877.393.5273</div>
                      <div><span>F:</span> 403.291.6485 <span>Toll Free Fax:</span> 1.877.365.8775</div>
                      <div>#12 2219 - 35th Ave NE Calgary, AB T2E 6W3</div>
                      <div><span>www.doctorsopticallab.com</span></div>
                  </div>
              </div>
          </div>
          <div className="lab-box">
              <div className="flbox">
                  <div className="fleft page-col15 lab-right bce">JOB TYPE</div>
                  <div className="fleft page-col25 tcenter"><CheckToggle type="lab-check2" />UNCUT</div>
                  <div className="fleft page-col30 tcenter"><CheckToggle type="lab-tick2" />Rx COMPLETE</div>
                  <div className="fleft page-col30 tcenter"><CheckToggle type="lab-check2" />REPAIR/MISC</div>
              </div>
              <div className="flbox">
                  <div className="fleft page-col20 lab-right bce">ACCOUNT#</div>
                  <div className="fleft page-col50 lab-right bce">REFERENCE(LAST NAME,FIRST NAME)</div>
                  <div className="fleft page-col10 tcenter lab-right bce">DAY</div>
                  <div className="fleft page-col10 tcenter lab-right bce">MON</div>
                  <div className="fleft page-col10 tcenter bce">YEAR</div>
              </div>
              <div className="flbox">
                  <div className="fleft ofh page-col20 lab-right lab-fs5 tcenter lab-italic">{accountId}</div>
                  <div className="fleft ofh page-col50 lab-right lab-fs5 ttu lab-italic">{`${clientData.client_last_name}, ${clientData.client_first_name} #${clientData.client_number}`}</div>
                  <div className="fleft ofh page-col10 tcenter lab-right lab-fs5 fwb lab-italic">{todayDay}</div>
                  <div className="fleft ofh page-col10 tcenter lab-right lab-fs5 fwb lab-italic">{todayMonth}</div>
                  <div className="fleft ofh page-col10 tcenter lab-fs5 fwb lab-italic">{todayYear}</div>
              </div>
              <div className="flwrap">
                  <div className="fleft ofh page-col5 bce">&nbsp;</div>
                  <div className="fleft ofh page-col15 tcenter lab-right bce">SPHERE</div>
                  <div className="fleft ofh page-col15 tcenter lab-right bce">CYLINDER</div>
                  <div className="fleft ofh page-col15 tcenter lab-right bce">AXIS</div>
                  <div className="fleft ofh page-col20 tcenter lab-right bce">PRISM</div>
                  <div className="fleft ofh page-col15 tcenter lab-right bce">FAR PD</div>
                  <div className="fleft ofh page-col15 tcenter bce">NEAR PD</div>
              </div>
              <div className="flwrap">
                  <div className="fleft ofh page-col5 tcenter lab-right lab-fs2">R</div>
                  <div className="fleft ofh page-col15 tcenter lab-right lab-fs5 lab-italic" contentEditable dangerouslySetInnerHTML={{ __html: examData?.R67 ?? '' }} />
                  <div className="fleft ofh page-col15 tcenter lab-right lab-fs5 lab-italic" contentEditable dangerouslySetInnerHTML={{ __html: examData?.R68 ?? '' }} />
                  <div className="fleft ofh page-col15 tcenter lab-right lab-fs5 lab-italic" contentEditable dangerouslySetInnerHTML={{ __html: examData?.R69 ?? '' }} />
                  <div className="fleft ofh page-col20 tcenter lab-right lab-fs5 lab-italic" contentEditable dangerouslySetInnerHTML={{ __html: `${examData?.R71 ?? ''} ${examData?.R72 ?? ''}`}} />
                  <div className="fleft ofh page-col15 tcenter lab-right lab-fs5 lab-italic" contentEditable dangerouslySetInnerHTML={{ __html: examData?.R111 ?? '' }} />
                  <div className="fleft ofh page-col15 tcenter lab-fs5 lab-italic" contentEditable dangerouslySetInnerHTML={{ __html: examData?.R112 ?? '' }} />
              </div>
              <div className="flwrap">
                  <div className="fleft ofh page-col5 tcenter lab-right lab-fs2">L</div>
                  <div className="fleft ofh page-col15 tcenter lab-right lab-fs5 lab-italic" contentEditable dangerouslySetInnerHTML={{ __html: examData?.L67 ?? '' }} />
                  <div className="fleft ofh page-col15 tcenter lab-right lab-fs5 lab-italic" contentEditable dangerouslySetInnerHTML={{ __html: examData?.L68 ?? '' }} />
                  <div className="fleft ofh page-col15 tcenter lab-right lab-fs5 lab-italic" contentEditable dangerouslySetInnerHTML={{ __html: examData?.L69 ?? '' }} />
                  <div className="fleft ofh page-col20 tcenter lab-right lab-fs5 lab-italic" contentEditable dangerouslySetInnerHTML={{ __html: `${examData?.L71 ?? ''} ${examData?.L72 ?? ''}` }} />
                  <div className="fleft ofh page-col15 tcenter lab-right lab-fs5 lab-italic" contentEditable dangerouslySetInnerHTML={{ __html: examData?.L111 ?? '' }} />
                  <div className="fleft ofh page-col15 tcenter lab-fs5 lab-italic" contentEditable dangerouslySetInnerHTML={{ __html: examData?.L112 ?? '' }} />
              </div>
              <div className="flbox">
                  <div className="fleft ofh page-col5 bce">&nbsp;</div>
                  <div className="fleft ofh page-col15 tcenter lab-right bce">ADDITION</div>
                  <div className="fleft ofh page-col10 tcenter lab-right bce">SEG.HT</div>
                  <div className="fleft ofh page-col10 tcenter lab-right bce">OC HT</div>
                  <div className="fleft ofh page-col10 tcenter lab-right bce">BASE</div>
                  <div className="fleft ofh page-col50 tcenter fwb bce">CUSTOMIZED LENSE ONLY</div>
              </div>
              <div className="flbox">
                  <div className="fleft ofh page-col5 tcenter lab-right lab-fs2">R</div>
                  <div className="fleft ofh page-col15 tcenter lab-right lab-fs5 lab-italic" contentEditable dangerouslySetInnerHTML={{ __html: examData?.R75 ?? '' }} />
                  <div className="fleft ofh page-col10 tcenter lab-right lab-fs5 lab-italic" contentEditable dangerouslySetInnerHTML={{ __html: examData?.R114 ?? '' }} />
                  <div className="fleft ofh page-col10 tcenter lab-right lab-fs5 lab-italic" contentEditable dangerouslySetInnerHTML={{ __html: '&nbsp;' }} />
                  <div className="fleft ofh page-col10 tcenter lab-right lab-fs5 lab-italic" contentEditable dangerouslySetInnerHTML={{ __html: '&nbsp;' }} />
                  <div className="fleft ofh page-col10 tcenter lab-right lab-fs1 bce">Office Degress.</div>
                  <div className="fleft ofh page-col10 tcenter lab-right lab-fs1 bce">Frame Wrap</div>
                  <div className="fleft ofh page-col10 tcenter lab-right lab-fs1 bce">Panto Angle</div>
                  <div className="fleft ofh page-col10 tcenter lab-right lab-fs1 bce">Vertex Exam</div>
                  <div className="fleft ofh page-col10 tcenter lab-fs1 bce">Vertex Position</div>
              </div>
              <div className="flbox">
                  <div className="fleft ofh page-col5 tcenter lab-right lab-fs2">L</div>
                  <div className="fleft ofh page-col15 tcenter lab-right lab-fs5 lab-italic" contentEditable dangerouslySetInnerHTML={{ __html: examData?.L75 ?? '' }} />
                  <div className="fleft ofh page-col10 tcenter lab-right lab-fs5 lab-italic" contentEditable dangerouslySetInnerHTML={{ __html: examData?.L114 ?? '' }} />
                  <div className="fleft ofh page-col10 tcenter lab-right lab-fs5 lab-italic" contentEditable dangerouslySetInnerHTML={{ __html: '&nbsp;' }} />
                  <div className="fleft ofh page-col10 tcenter lab-right lab-fs5 lab-italic" contentEditable dangerouslySetInnerHTML={{ __html: '&nbsp;' }} />
                  <div className="fleft ofh page-col10 tcenter lab-right lab-fs5 lab-italic" contentEditable dangerouslySetInnerHTML={{ __html: '&nbsp;' }} />
                  <div className="fleft ofh page-col10 tcenter lab-right lab-fs5 lab-italic" contentEditable dangerouslySetInnerHTML={{ __html: '&nbsp;' }} />
                  <div className="fleft ofh page-col10 tcenter lab-right lab-fs5 lab-italic" contentEditable dangerouslySetInnerHTML={{ __html: '&nbsp;' }} />
                  <div className="fleft ofh page-col10 tcenter lab-right lab-fs5 lab-italic" contentEditable dangerouslySetInnerHTML={{ __html: '&nbsp;' }} />
                  <div className="fleft ofh page-col10 tcenter lab-fs5 lab-italic" contentEditable dangerouslySetInnerHTML={{ __html: '&nbsp;' }} />
              </div>
              <div className="flbox">
                  <div className="fleft ofh page-col5 bce">&nbsp;</div>
                  <div className="fleft ofh page-col25 tcenter lab-right bce">LENS TYPE</div>
                  <div className="fleft ofh page-col15 tcenter lab-right bce">MATERIAL</div>
                  <div className="fleft ofh page-col15 tcenter lab-right bce">INDEX</div>
                  <div className="fleft ofh page-col30 tcenter lab-right bce">BLUE/POLAR/TRANS</div>
                  <div className="fleft ofh page-col10 tcenter bce">COLOR</div>
              </div>
              <div className="flbox">
                  <div className="flwrap fleft page-col30 lab-right px0">
                      <div className="fleft ofh lab-lh28 page-col20 tcenter lab-right lab-fs2 lab-bottom">R</div>
                      <div className="fleft ofh lab-lh28 page-col80 tcenter lab-bottom lab-fs5 lab-italic" contentEditable dangerouslySetInnerHTML={{ __html: lensTypeRight }} />
                      <div className="fleft ofh lab-lh28 page-col20 tcenter lab-right lab-fs2">L</div>
                      <div className="fleft ofh lab-lh28 page-col80 tcenter lab-fs5 lab-italic" contentEditable dangerouslySetInnerHTML={{ __html: lensTypeLeft }} />
                  </div>
                  <div className="fleft page-col15 lab-right">
                      <div className='lab-lh14' id="MATERIALPLASTIC"><CheckToggle type={checkMaterialplastic ? 'lab-tick' : 'lab-check'} />Plastic</div>
                      <div className='lab-lh14' id="MATERIALPOLY"><CheckToggle type={checkMaterialPoly ? 'lab-tick' : 'lab-check'} />Poly</div>
                      <div className='lab-lh14' id="MATERIALTRIVEX"><CheckToggle type={checkMaterialTrivex ? 'lab-tick' : 'lab-check'} />Trivex</div>
                      <div className='lab-lh14'><CheckToggle type="lab-check" />Other</div>
                  </div>
                  <div className="flwrap page-col15 lab-right px0">
                      <div className="fleft ofh lab-lh28 page-col100 lab-bottom lab-fs5 tcenter lab-italic" contentEditable dangerouslySetInnerHTML={{ __html: lensIndexRight }} />
                      <div className="fleft ofh lab-lh28 page-col100 tcenter lab-fs5 lab-italic" contentEditable dangerouslySetInnerHTML={{ __html: lensIndexLeft }} />
                  </div>
                  <div className="flwrap page-col30 lab-right px0">
                      <div className="fleft ofh lab-lh28 page-col100 lab-bottom lab-fs5 tcenter lab-italic" contentEditable dangerouslySetInnerHTML={{ __html: lensFilterRight }} />
                      <div className="fleft ofh lab-lh28 page-col100 lab-fs5 tcenter lab-italic" contentEditable dangerouslySetInnerHTML={{ __html: lensFilterLeft }} />
                  </div>
                  <div className="fleft page-col10 pls">
                      <div className="lab-lh14"><CheckToggle type="lab-check" />Grey</div>
                      <div className="lab-lh14"><CheckToggle type="lab-check" />Brown</div>
                      <div className="lab-lh14"><CheckToggle type="lab-check" />Other</div>
                  </div>
              </div>
              <div className="flbox">
                  <div className="fleft ofh page-col40 lab-right bce">COATING:</div>
                  <div className="fleft ofh page-col15 tcenter lab-right bce">PL TINTS:</div>
                  <div className="fleft ofh page-col30 tcenter lab-right">
                      <CheckToggle type="lab-check2" />SOLID &nbsp;
                      <CheckToggle type="lab-check2" />GRADIENT
                  </div>
                  <div className="fleft page-col15 tcenter bce">
                      <CheckToggle type="lab-check2" /> MATCH
                  </div>
              </div>
              <div className="flbox">
                  <div className="fleft page-col40 lab-right">
                      <div className="fleft cl9">
                          <div className="lab-lh14" id="ULTRAARECC"><CheckToggle type={checkUltraARECC ? 'lab-tick' : 'lab-check'} />Ultra AR ECC</div>
                          <div className="lab-lh14" id="ULTRAAR"><CheckToggle type={checkUltraAR ? 'lab-tick' : 'lab-check'} />Ultra AR</div>
                          <div className="lab-lh14" id="ULTRABACKAR"><CheckToggle type={checkUltraBACKAR ? 'lab-tick' : 'lab-check'} />Ultra Back AR</div>
                          <div className="lab-lh14" id="SEECOAT"><CheckToggle type={checkSeeCoat ? 'lab-tick' : 'lab-check'} />SeeCoat</div>
                          <div className="lab-lh14" id="ICE"><CheckToggle type={checkICE ? 'lab-tick' : 'lab-check'} />ICE</div>
                          <div className="lab-lh14" id="HCC"><CheckToggle type={checkHCC ? 'lab-tick' : 'lab-check'} />HCC</div>
                          <div className="lab-lh14" id="MULTICLEAR"><CheckToggle type={checkMultiClear ? 'lab-tick' : 'lab-check'} />Multi Clear</div>
                      </div>
                      <div className="fleft cl11">
                          <div className="lab-lh14" id="HARDCOAT"><CheckToggle type={checkHardCoat ? 'lab-tick' : 'lab-check'} />Hard Coat</div>
                          <div className="lab-lh14" id="HARDCOATTINT"><CheckToggle type={checkHardCoatTint ? 'lab-tick' : 'lab-check'} />Hard Coat (Tint)</div>
                          <div className="lab-lh14" id="NIKONHC"><CheckToggle type={checkNikonHC ? 'lab-tick' : 'lab-check'} />Nikon HC</div>
                          <div className="lab-lh14" id="SRC2"><CheckToggle type={checkSRC2 ? 'lab-tick' : 'lab-check'} />SRC2</div>
                          <div className="lab-lh14" id="UV400ONPLASTIC"><CheckToggle type={checkUV400ONPlastic ? 'lab-tick' : 'lab-check'} />UV400 on plastic</div>
                          <div className="lab-lh14" id="EDGEPOLISH"><CheckToggle type={checkEdgePolish ? 'lab-tick' : 'lab-check'} />Edge Polish</div>
                          <div className="lab-lh14" id="CHEMHARDENING"><CheckToggle type={checkChemHardening ? 'lab-tick' : 'lab-check'} />Chem Hardening</div>
                      </div>
                  </div>
                  <div className="fleft page-col60 px0">
                      <div className="flbox mb0">
                          <div className="fleft ofh page-col25 lab-right lab-bottom pl1 bce">TINT COLOR:</div>
                          <div className="fleft ofh page-col75 lab-bottom lab-fs5 lab-italic" contentEditable dangerouslySetInnerHTML={{ __html: '&nbsp;' }} />
                      </div>
                      <div className="flbox mb0">
                          <div className="fleft ofh page-col30 lab-right lab-bottom pl1 bce">MIRROR COLOR:</div>
                          <div className="fleft ofh page-col70 lab-bottom lab-fs5 lab-italic" contentEditable dangerouslySetInnerHTML={{ __html: '&nbsp;' }} />
                      </div>
                      <div className="flwrap">
                          <div className="fleft ofh page-col100 pl1">ADDITIONAL INSTRUCTION:</div>
                          <div className="fleft ofh page-col100 pl1 lab-fs5 lab-italic tcenter" contentEditable dangerouslySetInnerHTML={{ __html: instruction }} id="INSTRUCTION" />
                      </div>
                  </div>
              </div>
              <div className="flbox">
                  <div className="fleft page-col35 tcenter lab-right lab-fs3 bce">FRAME INFORMATION</div>
                  <div className="fleft page-col20 tcenter lab-right lab-fs3 bce">SAFETY LENS</div>
                  <div className="fleft page-col45 tcenter">
                      <CheckToggle type="lab-check2" /> INDUSTRIAL &nbsp; &nbsp;
                      <CheckToggle type="lab-check2" /> MONOGRAM
                  </div>
              </div>
              <div className="flbox">
                  <div className="fleft page-col35 tcenter lab-right px0">
                      <div className="flwrap mb0">
                          <div className="fleft page-col50 lab-bottom lab-right bce">MODEL</div>
                          <div className="fleft page-col50 lab-bottom bce">COLOR</div>
                          <div className="fleft page-col50 lab-bottom lab-right lab-fs5 lab-italic" contentEditable dangerouslySetInnerHTML={{ __html: frameData?.D61 ?? '' }} id="LMODEL" />
                          <div className="fleft page-col50 lab-bottom lab-fs5 lab-italic" contentEditable dangerouslySetInnerHTML={{ __html:  frameData?.D54 ?? '' }} id="LCOLOR" />
                          <div className="fleft page-col50 lab-bottom lab-right bce">SIZE</div>
                          <div className="fleft page-col50 lab-bottom bce">SUPPLIER</div>
                          <div className="fleft page-col50 lab-bottom lab-right lab-fs5 lab-italic" contentEditable dangerouslySetInnerHTML={{ __html: frameData?.D43 ?? '' }} id="LSIZE" />
                          <div className="fleft page-col50 lab-bottom lab-fs5 lab-italic" contentEditable dangerouslySetInnerHTML={{ __html: frameData?.D41 ?? '' }} id="LLINE" />
                      </div>
                      <div className="flbox mb0">
                          <div className="fleft page-col15 lab-bottom lab-right">A</div>
                          <div className="fleft page-col35 lab-bottom lab-right lab-fs5 lab-italic" contentEditable dangerouslySetInnerHTML={{ __html: '&nbsp;' }} />
                          <div className="fleft page-col50 lab-bottom tleft"><CheckToggle type="lab-check" />Plastic</div>
                      </div>
                      <div className="flbox mb0">
                          <div className="fleft page-col15 lab-bottom lab-right">B</div>
                          <div className="fleft page-col35 lab-bottom lab-right lab-fs5 lab-italic" contentEditable dangerouslySetInnerHTML={{ __html: '&nbsp;' }} />
                          <div className="fleft page-col50 lab-bottom tleft"><CheckToggle type="lab-check" />Metleft</div>
                      </div>
                      <div className="flbox mb0">
                          <div className="fleft page-col15 lab-bottom lab-right">ED</div>
                          <div className="fleft page-col35 lab-bottom lab-right lab-fs5 lab-italic" contentEditable dangerouslySetInnerHTML={{ __html: '&nbsp;' }} />
                          <div className="fleft page-col50 lab-bottom tleft"><CheckToggle type="lab-check" />Nylon</div>
                      </div>
                      <div className="flbox mb0">
                          <div className="fleft page-col15 lab-bottom lab-right">DBL</div>
                          <div className="fleft page-col35 lab-bottom lab-right lab-fs5 lab-italic" contentEditable dangerouslySetInnerHTML={{ __html: '&nbsp;' }} />
                          <div className="fleft page-col50 lab-bottom tleft"><CheckToggle type="lab-check" />Drill/Notch.</div>
                      </div>
                      <div className="flbox mb0">
                          <div className="fleft page-col50 lab-bottom lab-right"><CheckToggle type="lab-check" />Frame to fol.</div>
                          <div className="fleft page-col50 lab-bottom tleft"><CheckToggle type="lab-check" />Metleft Inline</div>
                      </div>
                      <div className="flbox mb0">
                          <div className="flwrap fleft page-col50 lab-right tleft">
                              <div className="fleft page-col100 lab-bottom pl1"><CheckToggle type="lab-tick" />Enclosed</div>
                              <div className="fleft page-col100 pl1"><CheckToggle type="lab-check" />Supply<br /><br /></div>
                          </div>
                          <div className="fleft page-col50 tleft">
                              <div className="fleft cl20"><CheckToggle type="lab-check" />Wrap Frame</div>
                              <div className="fleft page-col100 pl3"><CheckToggle type="lab-check" />8 Base</div>
                              <div className="fleft page-col100 pl3"><CheckToggle type="lab-check" />6 Base</div>
                          </div>
                      </div>
                  </div>
                  <div className="fleft page-col65 tcenter">
                      <div className="flbox mb0">
                          <div className="fleft page-col15 tcenter lh14 ptb">N<br/>A<br/>S<br/>A<br/>L<br/><CheckToggle type="lab-check2" /></div>
                          <div className="fleft page-col70 pt1">
                              <div className="lab-centerbox">
                                  <div>
                                      <div>
                                          <div>
                                              &nbsp;
                                          </div>
                                      </div>
                                  </div>
                                  <span className="line1"></span>
                                  <span className="line2"></span>
                                  <span className="dot1"></span>
                                  <span className="dot2"></span>
                                  <span className="dot3"></span>
                                  <span className="dot4"></span>
                                  <span className="dot5"></span>
                                  <span className="dot6"></span>
                                  <span className="dot7"></span>
                                  <span className="dot8"></span>
                                  <span className="dot9"></span>
                                  <span className="dot10"></span>
                                  <span className="dot11"></span>
                                  <span className="dot12"></span>
                                  <span className="title1">30 &nbsp;&nbsp; 25 &nbsp;&nbsp; 20 &nbsp;&nbsp; 15</span>
                                  <span className="title2">15 &nbsp;&nbsp; 20 &nbsp;&nbsp; 25 &nbsp;&nbsp; 30</span>
                              </div>
                          </div>
                          <div className="fleft page-col15 tcenter lh14 ptb">N<br/>A<br/>S<br/>A<br/>L<br/><CheckToggle type="lab-check2" /></div>
                      </div>
                      <div className="page-col100 tcenter lab-fs4 mb0">*LENS TRACING - PLEASE CHECK NASAL BOX SIZE</div>
                  </div>
              </div>
          </div>
          <Field.PrintedOn />
        </Control.Print.Data>    
      </>)}
      {showMenu && (<div ref={contextMenuRef}><Control.PrintContextMenu keyId={keyId} showMenu={showMenu} formName={formName}  setShowMenu={setShowMenu} Privilege={Privilege} pos={menuPosition} /></div>)}
      <Actions.Print />
    </Control.Print.Frame>
  );
};

export default LabOrderPrint;